import { NavLink } from 'react-router-dom';

// Orden de lectura izquierda a derecha de los 3 destinos flexibles: Clientes y Trámites van
// antes de Inicio, Turnos va después — ver el armado final en BottomNav (Clientes, Trámites,
// Inicio, Turnos, Más), con Inicio al medio a propósito.
const SLOTS_FIJOS = [
    { id: 'clientes', label: 'Clientes', icon: 'bi bi-people-fill' },
    { id: 'tramites', label: 'Trámites', icon: 'bi bi-journal-richtext' },
    { id: 'recepcion', label: 'Turnos', icon: 'bi bi-calendar-check-fill' },
];

// Arma los 3 destinos del medio (Trámites/Clientes/Turnos) con sus secciones fijas cuando el
// rol las tiene. Si al usuario le falta alguna, se completa con la primera sección visible
// restante en el orden de GRUPOS_NAV (mismo orden de prioridad que ya usa el riel de escritorio)
// — así ningún rol se queda con menos de 3 destinos si tiene otras secciones disponibles. Con
// los 6 roles reales de hoy (ver auth/roles.js) los 3 fijos siempre están, el fallback no se
// ejercita en la práctica pero debe seguir andando si roles.js cambia.
function construirSlotsMedio(seccionesVisibles, gruposVisibles) {
    const usados = new Set();
    const slots = [];

    SLOTS_FIJOS.forEach((fijo) => {
        const seccion = seccionesVisibles.find((s) => s.id === fijo.id && (s.items?.length || 0) > 0);
        if (seccion) {
            slots.push({ id: fijo.id, to: seccion.items[0].to, label: fijo.label, icon: fijo.icon });
            usados.add(fijo.id);
        }
    });

    if (slots.length < 3) {
        gruposVisibles
            .filter((grupo) => grupo.id !== 'turnos' && !usados.has(grupo.id))
            .forEach((grupo) => {
                if (slots.length >= 3) return;
                const primeraSeccion = grupo.secciones.find((s) => (s.items?.length || 0) > 0);
                if (!primeraSeccion) return;
                slots.push({ id: grupo.id, to: primeraSeccion.items[0].to, label: grupo.title, icon: grupo.icon });
                usados.add(grupo.id);
            });
    }

    return slots;
}

// Bottom nav fija de la versión mobile: Inicio (sin guard de permiso, ver App.js) va al medio,
// no primero — Clientes/Trámites antes, Turnos después, Más siempre al final (abre el drawer
// con el árbol completo, components/mobile/DrawerMas). No asume 5 hijos fijos en el layout
// (flex, no grid a fuego) porque el fallback puede dejar menos de 3 destinos flexibles.
export default function BottomNav({ seccionesVisibles, gruposVisibles, overlayAbierto, onAbrirMenu }) {
    const slotsMedio = construirSlotsMedio(seccionesVisibles, gruposVisibles);
    // Hasta 2 antes de Inicio (Clientes, Trámites) y el resto después (Turnos) — con menos de
    // 3 slots por el fallback, el resto de después queda vacío en vez de forzar el reparto.
    const slotsAntes = slotsMedio.slice(0, 2);
    const slotsDespues = slotsMedio.slice(2);
    const masActivo = overlayAbierto === 'drawer';

    const renderSlot = (slot) => (
        <NavLink
            key={slot.id}
            to={slot.to}
            className={({ isActive }) => `mob-bottom-nav-item mob-tocable ${isActive ? 'activo' : ''}`}
        >
            <i className={slot.icon} aria-hidden="true" />
            <span>{slot.label}</span>
        </NavLink>
    );

    return (
        <nav className="mob-bottom-nav" aria-label="Navegación principal">
            {slotsAntes.map(renderSlot)}

            <NavLink
                to="/home"
                className={({ isActive }) => `mob-bottom-nav-item mob-tocable ${isActive ? 'activo' : ''}`}
            >
                <i className="bi bi-house-door-fill" aria-hidden="true" />
                <span>Inicio</span>
            </NavLink>

            {slotsDespues.map(renderSlot)}

            <button
                type="button"
                className={`mob-bottom-nav-item mob-tocable ${masActivo ? 'activo' : ''}`}
                onClick={onAbrirMenu}
                aria-expanded={masActivo}
                aria-label="Más opciones"
            >
                <i className="bi bi-grid-3x3-gap-fill" aria-hidden="true" />
                <span>Más</span>
            </button>
        </nav>
    );
}
